export const FETCH_PROMO_CODES_DATA = "FETCH_PROMO_CODES_DATA";
export const FETCH_PROMO_CODES_SUCCESS = "FETCH_PROMO_CODES_SUCCESS";
export const FETCH_PROMO_CODES_FAILURE = "FETCH_PROMO_CODES_FAILURE";

export const FETCH_PROMO_CODES_EDIT_DATA = "FETCH_PROMO_CODES_EDIT_DATA";
export const FETCH_PROMO_CODES_EDIT_SUCCESS = "FETCH_PROMO_CODES_EDIT_SUCCESS";
export const FETCH_PROMO_CODES_EDIT_FAILURE = "FETCH_PROMO_CODES_EDIT_FAILURE";